module.exports = __webpack_public_path__ + "static/img/rank_20.a048a73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_20.png
// module id = riZD
// module chunks = 1